import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from '@mui/material';
export const TextDivider = props => {
    const height = props.collapseSmall ? { xs: 0, sm: 0, md: '1em', lg: '1em', xl: '1em' } : '1em';
    const mx = props.collapseSmall ? { xs: 0.25, sm: 0.25, md: 1, lg: 1, xl: 1 } : 1;
    const my = props.collapseSmall ? { xs: 0.25, sm: 0.25, md: 0, lg: 0, xl: 0 } : 0;
    const bgcolor = props.backgroundColor ?? '#151515';
    return _jsx(Divider, { orientation: 'vertical', sx: { alignSelf: 'center', height, mx, my, bgcolor } });
};
//# sourceMappingURL=text-divider.js.map